export default __webpack_public_path__ + "static/N0022-f94249877ddec148213948780f56de8a.png";